'use client';
import type { ReactElement } from 'react';
import { Mail, Copy } from 'lucide-react';
import Link from 'next/link';
import CallbackButton from '../ui/callback-button';
import { Alert } from '@mui/material';
import { memo, useState } from 'react';
import TgVector from '../ui/svg/contacts/tgvector';
import FaqVector from '../ui/svg/contacts/faq-vector';

const ContactCard = ({ style }: any): ReactElement => {
  function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }
  const [hide, setHide] = useState(false);
  const hideHandler = (text: string) => {
    copyToClipboard(text);
    if (!hide) {
      setHide(true);
      const timer = setTimeout(() => setHide(false), 1000);
      return () => clearTimeout(timer);
    }
  };
  return (
    <section
      className={`flex w-full flex-col gap-4 pb-40 pt-8 ${style} relative`}
    >
      <h2>Контакты</h2>
      <p className="mt-6 text-sm opacity-60">
        Г. Москва, Кутузовский проспект 2/1к1Б
      </p>
      <p>Время работы:</p>
      <p>Режим работы бутика по предварительной записи:</p>
      <p>Ежедневно с 11:00 до 20:00</p>
      <div className="flex flex-col gap-4">
        <div
          className="group flex items-center gap-4"
          onClick={() => hideHandler('89162849576')}
        >
          <div className="flex items-center gap-4">
            <TgVector width={24} height={24} fill="none" strokeWidth={2} />
            <p className="text-sm">8 (916) 284-95-76</p>
          </div>
          <Copy size={14} className="opacity-50 group-active:opacity-100" />
        </div>
        <div
          className="group flex items-center gap-2"
          onClick={() => hideHandler('fashionist.community@gmail.com')}
        >
          <div className="flex items-center gap-4">
            <Mail width={24} height={24} strokeWidth={1} />
            <p className="text-sm">Fashionist.community@gmail.com</p>
          </div>
          <Copy size={14} className="opacity-50 group-active:opacity-100" />
        </div>
        <div className="flex items-center gap-4">
          <FaqVector width={24} height={24} fill="none" strokeWidth={1} />
          <p className="text-sm">Часто задаваемые вопросы</p>
        </div>
      </div>
      <div className="text-center">
        <div className="flex items-center gap-3">
          <CallbackButton />
        </div>
        <p className="mt-4 text-sm opacity-50">
          2024, Fashionist, все права защищены
        </p>
        <Link href={'/privacy-policy'}>
          <p className="mt-4 text-sm opacity-50">Политика конфиденциальности</p>
        </Link>
      </div>
      {hide && (
        <Alert
          icon={<Copy fontSize="inherit" color="gray" />}
          severity="info"
          className="fixed left-1/2 top-[10%] z-50 w-4/5 -translate-x-1/2 transform"
          sx={{
            bgcolor: '#323232',
            '& .MuiAlert-action': {
              color: '#fff',
              height: '24px',
            },
            '& .MuiAlert-message': {
              color: 'white',
            },
          }}
        >
          Копирование завершено.
        </Alert>
      )}
    </section>
  );
};

// Оборачиваем компонент в memo
export default memo(ContactCard);
